import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import KnowledgeBase from "@/pages/KnowledgeBase";
import ArticleDetail from "@/pages/ArticleDetail";
import Bookmarks from "@/pages/Bookmarks";
import Settings from "@/pages/Settings";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import AreebaResult from "@/pages/AreebaResult";
import Team from "@/pages/Team";
import InviteAccept from "@/pages/InviteAccept";
import Contracts from "@/pages/Contracts";
import Calendar from "@/pages/Calendar";
import LawFirm from "@/pages/LawFirm";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Synchronously detect Emergent OAuth callback (URL fragment) so we don't accidentally render the dashboard's auth check first.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
      <Route path="/chat/:conversation_id" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
      <Route path="/knowledge" element={<KnowledgeBase />} />
      <Route path="/article/:article_id" element={<ArticleDetail />} />
      <Route path="/bookmarks" element={<ProtectedRoute><Bookmarks /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
      <Route path="/billing/areeba/result" element={<ProtectedRoute><AreebaResult /></ProtectedRoute>} />
      <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/contracts" element={<ProtectedRoute><Contracts /></ProtectedRoute>} />
      <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
      <Route path="/lawfirm" element={<ProtectedRoute><LawFirm /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}
